<template>
  <div id="search" class="mainBlock">
    <div
      id="mainTop"
      style="
        width: 780px;
        position: absolute;
        top: 200px;
        left: calc(50% - 390px);
        padding-bottom: 60px;
      "
    >
      <div style="margin-bottom: 40px" class="logoBlock">
        <img src="../../../assets/img/topLog.png" width="50%" />
      </div>
      <div style="width: 780px" class="searchBlock d_flex">
        <input
          placeholder="请输入品名 规格搜索"
          v-model="keyWord"
          style="font-size: 16px"
          @keydown.enter="toSearchResult()"
          type="text"
        />
        <!-- <input
          placeholder="请输入品名 规格 材质 钢厂等搜索 如 冷轧卷 1.0*1250"
          v-model="keyWord"
          style="font-size: 16px"
          @keydown.enter="toSearchResult()"
          type="text"
        /> -->
        <div class="c_p" @click="toSearchResult()">
          <img
            style="height: 24px; width: 24px; margin-right: 14px"
            src="../../../assets/img/search.png"
          />百钢一下
        </div>
      </div>
      <div>
        <div style="margin-bottom: 16px">
          <div
            v-if="isRegister"
            @click="selectIndex = 0"
            :class="selectIndex === 0 ? 'active' : ''"
            class="dis_line c_p searchTab color666"
          >
            百钢推荐
          </div>
          <div
            @click="selectIndex = 1"
            :class="selectIndex === 1 ? 'active' : ''"
            class="dis_line c_p searchTab m_l_10 color666"
          >
            热门公告
          </div>
          <div
            v-if="isRegister"
            @click="selectIndex = 2"
            :class="selectIndex === 2 ? 'active' : ''"
            class="dis_line c_p searchTab m_l_10 color666"
          >
            钢铁导航
          </div>
        </div>
        <!--        <div v-show="recentLocalKey.length > 0 && selectIndex === 0"  class="listBlock recentSearchDiv">-->
        <!--          <div @click="toSearchResult(item.keyword)" v-for="(item, index) in recentLocalKey" style="display: inline-block" :key="index" class="listItem listItem2 d_flex c_p">-->
        <!--            <div>-->
        <!--&lt;!&ndash;              <div class="sortNum">&ndash;&gt;-->
        <!--&lt;!&ndash;                {{ index + 1 }}&ndash;&gt;-->
        <!--&lt;!&ndash;              </div>&ndash;&gt;-->
        <!--              {{ item.keyword }}-->
        <!--&lt;!&ndash;              <div class="deleteRecent">+</div>&ndash;&gt;-->
        <!--            </div>-->
        <!--          </div>-->
        <!--        </div>-->
        <div v-show="selectIndex === 0" class="listBlock recentSearchDiv">
          <div
            class="newItemList"
            :key="index"
            v-for="(item, index) in topBannerList"
          >
            <a target="_blank" :href="item.name.split('^_^')[1] || ''">
              <p><img :src="item.url" width="100%" alt="" /></p>
              <p>{{ item.name.split("^_^")[0] }}</p>
            </a>
          </div>
        </div>
        <div v-show="selectIndex === 1" class="listBlock imgScorllPlace">
          <div
            style="
              vertical-align: top;
              width: calc(100% - 250px);
              margin-right: 40px;
            "
            class="dis_line"
          >
            <div
              @click="getNoticeDetail(item)"
              class="noticeInfo"
              :key="index"
              v-for="(item, index) in noticeList"
            >
              <p>{{ item.title }}</p>
              <p class="font12 color666">
                <span style="color: #d71e1e; margin-right: 5px">热</span
                ><span>{{ item.createTime }}</span>
              </p>
            </div>
          </div>
          <div style="vertical-align: top; width: 200px" class="dis_line">
            <div class="d_flex" style="margin-bottom: 16px">
              <div class="f_w">热门搜索</div>
              <div @click="changeHotKey" class="changeBtn c_p">换一换</div>
            </div>
            <div class="listBlock">
              <div
                @click="toSearchResult(item.hotWord)"
                :key="index"
                v-for="(item, index) in hotKeyList"
                style="width: 100%"
                class="listItem d_flex c_p"
              >
                <div>
                  <div class="sortNum">{{ index + 1 }}</div>
                  {{ item.hotWord }}
                </div>
                <!-- 去除计数器 -->
                <!-- <div>{{ returnNum(item.num) }}</div> -->
              </div>
            </div>
          </div>
        </div>
        <div v-show="selectIndex === 2" class="listBlock recentSearchDiv">
          <div
            class="newItemList"
            :key="index"
            v-for="(item, index) in middleBannerList"
          >
            <a target="_blank" :href="item.name.split('^_^')[1] || ''">
              <p><img :src="item.url" width="100%" alt="" /></p>
              <p>{{ item.name.split("^_^")[0] }}</p>
            </a>
          </div>
        </div>
        <!--        <div v-show="selectIndex === 2"  class="listBlock imgScorllPlace d_flex">-->
        <!--          <imgScorll v-if="showImg" :linkList="linkList" :imgList="bannerList"></imgScorll>-->
        <!--        </div>-->
      </div>
    </div>
    <model
      v-if="showNoticeDetail"
      :title="'公告详情'"
      :minWidth="'500px'"
      v-on:on-cancel="showNoticeDetail = false"
      v-on:on-confirm="showNoticeDetail = false"
    >
      <div style="padding: 20px">
        <div class="f_w font18">{{ noticeDetail.title }}</div>
        <div class="color666 font12">{{ noticeDetail.createTime }}</div>
        <div style="margin: 10px 0">{{ noticeDetail.content }}</div>
      </div>
    </model>
  </div>
</template>

<script>
export default {
  name: 'search',
  data () { // 所有的数据都写在里面
    return {
      isRegister: window.localStorage.getItem('memberId'),
      MemberInfo: JSON.parse(window.localStorage.getItem('MemberInfo') || '{}'),
      noticeDetail: {},
      showNoticeDetail: false,
      linkList: [],
      noticeList: [],
      hotKeyList: [],
      bannerList: [
        require('../../../assets/img/backgroundImg.png')
      ],
      showImg: false,
      noticeHtml: '',
      currentTab: 0,
      selectIndex: 1,
      keyWord: '',
      startIdx: 1,
      endIdx: 9,
      topBannerList: [],
      middleBannerList: [],
      recentLocalKey: JSON.parse(window.localStorage.getItem('recentLocalKey') || '[]')
    }
  },
  created () {
    document.title = '百钢一下 | 钢铁电商，百炼成钢'
    this.getHostKey()
    this.getNotice()
    this.getBannerList()
    this.getAllnewBanner()
  },
  destroyed () {
  },
  mounted () {

  },
  methods: {
    getAllnewBanner () {
      this.$axiox.get(`/baigang/app/home/queryBackgroundList`).then(p => {
        this.topBannerList = p.data.filter(e => {
          return e.type === 'top'
        })
        this.middleBannerList = p.data.filter(e => {
          return e.type === 'middle'
        })
        // this.topBannerList = p.data
      })
    },
    changeHotKey () {
      this.hotKeyList = []
      if (this.startIdx === 21) {
        this.startIdx = 1
      } else {
        this.startIdx = this.startIdx + 10
      }
      if (this.endIdx === 29) {
        this.endIdx = 9
      } else {
        this.endIdx = this.endIdx + 10
      }
      this.getHostKey()
    },
    returnNum (num) {
      if (num < 10000) {
        return num
      } else {
        return num / 1000 + '万'
      }
    },
    getNoticeDetail (item) {
      console.log(123)
      this.$axiox.get('/baigang/app/home/queryNoticeInfo/' + item.noticeId).then(p => {
        this.noticeDetail = p.data
        this.showNoticeDetail = true
      })
    },
    getHostKey () {
      this.$axiox.get('/baigang/app/good/queryHotWordList/' + this.startIdx + '/' + this.endIdx).then(p => {
        this.hotKeyList = p.data
      })
    },
    getBannerList () {
      this.$axiox.get('/baigang/app/home/queryBannerList/' + 1).then(p => {
        this.bannerList = []
        this.linkList = []
        for (let i = 0; i < p.data.length; i++) {
          if (!(i === 2 || i === 3)) {
            this.bannerList.push(p.data[i].imgUrl)
            this.linkList.push(p.data[i].title)
          }
        }
        this.showImg = true
      })
    },
    getNotice () {
      this.$axiox.get('/baigang/app/home/queryReleaseList').then(p => {
        this.noticeList = p.data.slice(0, 5)
      })
    },
    toSearchResult (keyWord) {
      if (keyWord || this.keyWord) {
        let flag = true
        for (let i = 0; i < this.recentLocalKey.length; i++) {
          if (this.keyWord === this.recentLocalKey[i].keyword || !this.keyWord.trim()) {
            flag = false
          }
        }
        if (!this.keyWord.trim()) {
          flag = false
        }
        if (flag) {
          this.recentLocalKey.splice(0, 0, { keyword: this.keyWord })
          if (this.recentLocalKey.length > 30) {
            this.recentLocalKey.splice(this.recentLocalKey.length - 1, 1)
          }
          window.localStorage.setItem('recentLocalKey', JSON.stringify(this.recentLocalKey))
        }
        this.$router.push({
          name: 'searchResult',
          query: {
            name: keyWord || this.keyWord
          }
        })
      }
    }
  }
}
</script>
<style scoped>
.mainBlock {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 400px;
}
.logoBlock {
  font-size: 30px;
  font-weight: bold;
  text-align: center;
}
.searchBlock {
  height: 50px;
  border: 1px solid #d71e1e;
  border-radius: 4px;
  margin-bottom: 30px;
}
.searchBlock input {
  flex: 1;
  height: 100%;
  border: none;
  border-radius: 8px 0px 0px 8px;
  padding: 0px 10px;
}
.searchBlock div {
  width: 130px;
  height: 100%;
  background: #d71e1e;
  color: #fff;
  font-weight: bold;
  text-align: center;
  line-height: 50px;
}
.changeBtn {
  width: 80px;
  height: 27px;
  font-size: 12px;
  line-height: 27px;
  background: #ffffff;
  border-radius: 2px;
  border: 1px solid #d71e1e;
  text-align: center;
  font-weight: 600;
  color: #d71e1e;
}
.hotSearch {
  color: #000000;
}
.hotSearch .listBlock {
  flex-wrap: wrap;
}
.listItem {
  margin-bottom: 8px;
  margin-right: 15px;
}
.listItem2 {
  padding: 4px 8px;
  border: 1px solid #eee;
  border-radius: 2px;
  transition: all 0.2s;
}
.listItem2:hover {
  background-color: #d71e1e;
  color: #fff;
  border: 1px solid transparent;
}
.listItem .sortNum {
  display: inline-block;
  width: 20px;
  height: 20px;
  line-height: 20px;
  color: #fff;
  font-size: 10px;
  text-align: center;
  background-color: #d71e1e;
  border-radius: 10px;
  margin-right: 10px;
}
.listItem .deleteRecent {
  position: absolute;
  right: 0;
  top: 0;
  width: 20px;
  height: 20px;
}
.imgScorllPlace {
  user-select: none;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/page/search.vue